import { OrganizationBreakdown, OrganizationBreakdownAz, OrganizationBreakdownEntry } from '../OrganizationBreakdown'

export const selectBreakdownByAz = (breakdown: OrganizationBreakdown): OrganizationBreakdownAz[] => {
  if (breakdown.organizationEntries.length === 0) {
    return []
  }

  const other = 'Other'

  const sortedEntries = breakdown.organizationEntries.sort(alphabetizeOrgsByTitle)

  const azMap = new Map<string, OrganizationBreakdownEntry[]>()

  sortedEntries.forEach((entry) => {
    if (firstLetterIsLatinAlphabet(entry.organization.title)) {
      const firstLetter = entry.organization.title[0].toLocaleUpperCase()
      upsertOrganizationBreakdownAzMap(firstLetter, entry, azMap)
    } else {
      upsertOrganizationBreakdownAzMap(other, entry, azMap)
    }
  })

  const organizationBreakdownAz = Array.from(azMap, ([category, orgs]) => ({ category, orgs }))

  if (organizationBreakdownAz[0].category === other) {
    const otherOrgs = organizationBreakdownAz.shift()
    if (otherOrgs) {
      organizationBreakdownAz.push(otherOrgs)
    }
  }

  return organizationBreakdownAz
}

const upsertOrganizationBreakdownAzMap = (
  category: string,
  entry: OrganizationBreakdownEntry,
  map: Map<string, OrganizationBreakdownEntry[]>
) => {
  const breakdown = map.get(category)
  if (breakdown !== undefined) {
    map.set(category, [...breakdown, entry])
  } else {
    map.set(category, [entry])
  }
}

const alphabetizeOrgsByTitle = (a: OrganizationBreakdownEntry, b: OrganizationBreakdownEntry) =>
  a.organization.title.localeCompare(b.organization.title)

const firstLetterIsLatinAlphabet = (str: string) => /[a-z]/gi.test(str[0])
